import { render } from "./BButton.vue?vue&type=template&id=5438f1aa&scoped=true&ts=true"
import script from "./BButton.vue?vue&type=script&lang=ts"
export * from "./BButton.vue?vue&type=script&lang=ts"

import "./BButton.vue?vue&type=style&index=0&id=5438f1aa&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5438f1aa"]])

export default __exports__